import { distanceToString } from '../units'
import EXIF from '../../lib/exif'

export const getImageMetaData = (image, units) => {
  if (!image) {
    return null
  }

  const { properties } = image
  const relativeAltitude =
    properties.relative_altitude != null ? properties.relative_altitude : null
  const altitude =
    relativeAltitude !== null
      ? properties.relative_altitude
      : properties.absolute_altitude

  const altitudeTitle = relativeAltitude !== null ? 'Altitude' : 'Abs. altitude'

  const camera =
    !properties.make || !properties.model
      ? '-'
      : `${properties?.make} ${properties?.model}`
  return [
    {
      title: 'Camera',
      value: camera,
    },
    {
      title: altitudeTitle,
      value: distanceToString(altitude, units),
    },
  ]
}

export function encodeSvgString(svg) {
  const decoded = decodeURIComponent(encodeURIComponent(svg))
  const b64String = btoa(decoded)
  const imgSource = `data:image/svg+xml;base64,${b64String}`
  return imgSource
}

export function getImageDimensions(uri) {
  const img = document.createElement('img')
  img.setAttribute('src', uri)
  img.crossOrigin = 'anonymous'

  return new Promise((resolve, reject) => {
    img.onload = function load() {
      resolve({ url: uri, width: img.width, height: img.height })
    }
    img.onerror = error =>
      reject(new Error(`Failed to load image ${uri}: ${error}`))
  })
}

export function svgUriToDataURI(uri) {
  const img = document.createElement('img')
  img.setAttribute('src', uri)
  img.crossOrigin = 'anonymous'

  return new Promise((resolve, reject) => {
    img.onload = function load() {
      const aspectRatio = img.width / img.height
      const canvas = document.createElement('canvas')
      if (aspectRatio > 1) {
        canvas.width = Math.min(img.width * 72, 1024)
        canvas.height = canvas.width / aspectRatio
      } else {
        canvas.height = Math.min(img.height * 72, 1024)
        canvas.width = canvas.height * aspectRatio
      }
      const ctx = canvas.getContext('2d')

      if (!ctx) {
        throw new Error('no canvas 2d context')
      }

      ctx.drawImage(img, 0, 0, canvas.width, canvas.height)
      const url = canvas.toDataURL('image/png')

      resolve({ url, width: canvas.width, height: canvas.height })
    }
    img.onerror = error =>
      reject(new Error(`Failed to load image ${uri}: ${error}`))
  })
}

export function svgToDataURI(svgData) {
  return svgUriToDataURI(encodeSvgString(svgData))
}

export async function thumbnail(uri) {
  const headers = new Headers()
  headers.append('Range', 'bytes=0-' + 64 * 1024)

  const res = await window.fetch(uri, { headers })
  if (res.status === 200 || res.status === 206) {
    const arrayBuffer = await res.arrayBuffer()
    const exif = EXIF.readFromBinaryFile(arrayBuffer)
    if (exif.thumbnail.blob) {
      const image = new Image()
      image.src = URL.createObjectURL(exif.thumbnail.blob)
      image.onload = () => URL.revokeObjectURL(image.src)
      return image
    } else {
      throw new Error(`No thumbnail found in image ${uri}.`)
    }
  } else {
    throw new Error(`Unexpected HTTP response ${res.status}.`)
  }
}
